import { render, staticRenderFns } from "./WorkWithUs.vue?vue&type=template&id=7636db96&scoped=true&"
import script from "./WorkWithUs.vue?vue&type=script&lang=js&"
export * from "./WorkWithUs.vue?vue&type=script&lang=js&"
import style0 from "./WorkWithUs.vue?vue&type=style&index=0&id=7636db96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636db96",
  null
  
)

export default component.exports